/**
 * 首页卡片在真实滚动容器的下方半屏时开始加载。
 *
 * rootMargin 的百分比按 root 宽度而非高度解析，因此这里必须根据容器高度生成 px。
 */
export const buildHomeCardVideoObserverOptions = (
  scrollRoot: Element
): IntersectionObserverInit => ({
  root: scrollRoot,
  rootMargin: `${scrollRoot.clientHeight / 2}px 0px`,
})

/**
 * 安全启动首页视频观察器。浏览器在构造、监听或回调阶段出现异常时，直接激活视频，
 * 让性能优化退化为原来的立即播放行为，绝不影响媒体展示。
 */
export const observeHomeCardVideo = (
  target: Element,
  scrollRoot: Element,
  activate: () => void
): (() => void) | undefined => {
  let observer: IntersectionObserver | undefined
  const disconnectSafely = () => {
    try {
      observer?.disconnect()
    } catch {
      // 清理失败不能冒泡到 React effect。
    }
  }

  try {
    observer = new IntersectionObserver((entries) => {
      try {
        if (entries.some((entry) => entry.isIntersecting)) activate()
      } catch {
        activate()
      }
    }, buildHomeCardVideoObserverOptions(scrollRoot))
    observer.observe(target)
    return disconnectSafely
  } catch {
    disconnectSafely()
    activate()
    return undefined
  }
}
